<template>
  <div>
    <div class="form my-4">
      <!-- Booking status -->
      <h6
        class="text-success font-weight-bold pl-5 mb-4"
        v-if="bookingSuccess === true"
      >Your cab has been booked succesfully.</h6>
      <h6
        class="text-danger font-weight-bold pl-5 mb-4"
        v-if="bookingSuccess === false"
      >Cannot complete your request, try again later.</h6>
      <!-- /Booking status -->
      <!-- Booking Form -->
      <form action @submit.prevent="book" class="booking-form">
        <BaseInput
          :label="'Pickup address'"
          :iconClass="'fleet-pickup'"
          v-model="pickup_addr"
          v-validate="'required'"
          data-vv-name="pickup"
        >
          <slot>
            <span v-show="errors.has('pickup')" class="error">This field is required.</span>
          </slot>
        </BaseInput>
        <BaseInput
          :label="'Dropoff address'"
          :iconClass="'fleet-drop'"
          v-model="dest_addr"
          v-validate="'required'"
          name="dest"
        >
          <slot>
            <span v-show="errors.has('dest')" class="error">This field is required.</span>
          </slot>
        </BaseInput>
        <BaseInput
          :type="'number'"
          :min="0"
          :label="'No of persons'"
          :iconClass="'fleet-person'"
          v-model="no_of_person"
          v-validate="'required'"
          name="person"
        >
          <slot>
            <span v-show="errors.has('person')" class="error">This field is required.</span>
          </slot>
        </BaseInput>
        <b-row>
          <b-col sm="6">
            <vc-date-picker
              v-model="booking_date"
              :input-props="{ class: &quot;form-control&quot;, placeholder: &quot;Select date&quot;, readonly : &quot;readonly&quot;}"
              :attributes="attrs"
              v-validate="'required'"
              name="date"
            ></vc-date-picker>
            <span v-show="errors.has('date')" class="error">This field is required.</span>
          </b-col>
          <b-col sm="6" class="mt-4 pt-3 mt-lg-0 pt-lg-0">
            <div class="form-input">
              <flat-pickr
                v-model="time"
                class="date-input"
                placeholder="Select Time"
                :config="timePickerConfig"
                v-validate="'required'"
                name="time"
              ></flat-pickr>
              <span v-show="errors.has('time')" class="error">This field is required.</span>
            </div>
          </b-col>
        </b-row>
        <div class="form-input">
          <v-select
            class="vue-select"
            v-model="vehicle"
            :searchable="false"
            :placeholder="'Select vehicle type'"
            label="vehicle_type"
            :options="vehicles"
            name="vehicles"
            v-validate="'required'"
          ></v-select>
          <span v-show="errors.has('vehicles')" class="error">This field is required.</span>
        </div>
        <BaseTextarea :label="'Other things that we should know'" :rows="3" v-model="remarks" />
        <!-- Submit -->
        <BaseButton class="mb-3" />
      </form>
      <!-- /Booking Form -->
    </div>
  </div>
</template>

<script>
import api from "@/api.js";
import auth from "@/auth.js";
import BaseInput from "@/components/ui/Elements/BaseInput";
import BaseTextarea from "@/components/ui/Elements/BaseTextarea";
import BaseButton from "@/components/ui/Elements/BaseButton";
import BaseDatepicker from "@/components/ui/Elements/BaseDatepicker";
import BaseTimepicker from "@/components/ui/Elements/BaseTimepicker";
export default {
  components: {
    BaseInput,
    BaseTextarea,
    BaseButton,
    BaseDatepicker,
    BaseTimepicker
  },
  data() {
    return {
      bookingSuccess: null,
      pickup_addr: "",
      dest_addr: "",
      no_of_person: "",
      vehicle: "",
      remarks: "",
      booking_date: "",
      time: "",
      vehicles: [],
      timePickerConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i:s",
        disableMobile: true
      },
      attrs: [
        {
          key: "today",
          highlight: true,
          dates: new Date()
        }
      ]
    };
  },
  computed: {
    bd_formatted() {
      return moment(this.booking_date).format("DD-MM-YYYY");
    }
  },
  mounted() {
    this.axios.get(`${api.url}/vehicle-types`).then(response => {
      this.vehicles = response.data;
    });
  },
  methods: {
    book() {
      if (auth.checkAuth()) {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.axios
              .post(`${api.url}/book-later`, {
                booking_type: 1,
                source_address: this.pickup_addr,
                dest_address: this.dest_addr,
                no_of_persons: this.no_of_person,
                vehicle_typeid: this.vehicle.id,
                journey_date: this.bd_formatted,
                journey_time: this.time,
                note: this.remarks,
                user_id: this.$store.state.user_id,
                api_token: this.$store.state.api_token
              })
              .then(response => {
                if (response.data.success === "1") {
                  this.bookingSuccess = true;
                  this.bookingSuccess = true;
                  [
                    this.pickup_addr,
                    this.dest_addr,
                    this.no_of_person,
                    this.vehicle,
                    this.remarks,
                    this.booking_date,
                    this.time
                  ] = "";
                } else {
                  this.bookingSuccess = false;
                }
              });
          } else {
            //
          }
        });
      } else {
        this.$router.push({
          name: "login",
          params: { book: true }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>